import React, { useEffect, useState } from "react";
import PageHeader from '../headers/PageHeader';
import TableWrapper from '../table/TableWrapper';
import CustomLoader from "../Loader";
import { useNavigate } from "react-router-dom";

function HomeWrapper() {

  const [isLoading, setIsLoading] = useState(true);
  const [batchData, setBatchData] = useState([]);
  const columnCount = 2;
  const [columns, setColumns] = useState(Array.from({ length: columnCount }, (_, colIndex) =>batchData.filter((_, i) => i % columnCount === colIndex)));
  const vendorId= sessionStorage.getItem("vendorId");
  const vendorPin= sessionStorage.getItem("vendorPin");
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(()=>{
    if(!vendorId || !vendorPin) navigate("/error",{state: {error: "Sign In to access the portal!"}});
    else getBatches();
  },[vendorId, vendorPin])

  useEffect(()=>{
    setColumns(Array.from({ length: columnCount }, (_, colIndex) =>batchData.filter((_, i) => i % columnCount === colIndex)));
  },[batchData])

  async function getBatches(){
    try {
      setIsLoading(true);
      const res= await fetch(`/server/fodder_portal_access_free_function/batches`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            Upin: vendorPin,
            vendorId: vendorId
        })
      })
      const response= await res.json();
      console.log(response);
      setBatchData(response.data);
    } catch (error) {
      
    }finally{
      setIsLoading(false);
    }
  }

  if(isLoading){
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        <CustomLoader size={10} color={"#000000"}/>
      </div>
    )
  }

  return (
    <>
      <div className="relative space-y-4 px-4 md:px-6 h-screen flex flex-col">
        {
          batchData.length==0?
          <div className="flex items-center justify-center font-semibold text-xl w-full h-full">No Batch Found</div>
          :
          <>
            <PageHeader newData={columns} setDisabled={setDisabled}/>
            <TableWrapper columns={columns} setColumns={setColumns} disabled={disabled}/>
          </>
        }  
      </div>
    </>
  )
}

export default HomeWrapper